import { BrowserRouter, Switch, Route } from "react-router-dom";
import Footer from "./components/Footer";
import HeaderContainer from "./containers/Header";
import LoginContainer from "./containers/Login";
import HomeContainer from "./containers/Home";
import MakerContainer from "./containers/Maker";
import { MainWrapper } from "./styles/AppStyle";

const App = () => {
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <HeaderContainer />
      <MainWrapper>
        <Switch>
          <Route exact path="/">
            <HomeContainer />
          </Route>
          <Route exact path="/login">
            <LoginContainer />
          </Route>
          <Route exact path="/maker">
            <MakerContainer />
          </Route>
        </Switch>
      </MainWrapper>
      <Footer />
    </BrowserRouter>
  );
};

export default App;
